/** Help center sections, in display order. Article frontmatter `section` must be one of these ids. */
export interface HelpSection {
  id: SectionId
  title: string
  description: string
}

export const SECTION_IDS = [
  'getting-started',
  'applications',
  'templates',
  'template-language',
  'events',
  'operating',
  'integrating',
  'reference',
] as const

export type SectionId = (typeof SECTION_IDS)[number]

export const SECTIONS: readonly HelpSection[] = [
  {
    id: 'getting-started',
    title: 'Getting started',
    description: 'What MailSmith does, the core ideas, and a guided first setup.',
  },
  {
    id: 'applications',
    title: 'Applications',
    description: 'Set up an application: senders, keys, variables, webhooks, and going live.',
  },
  {
    id: 'templates',
    title: 'Templates',
    description: 'Write, test, version, and publish the emails MailSmith sends.',
  },
  {
    id: 'template-language',
    title: 'Template language',
    description: 'Handlebars syntax, the data your templates can use, and every helper.',
  },
  {
    id: 'events',
    title: 'Events and rules',
    description: 'Describe the events your apps send and decide which emails they trigger.',
  },
  {
    id: 'operating',
    title: 'Operating',
    description: 'Follow messages, handle problems, and keep sending healthy.',
  },
  {
    id: 'integrating',
    title: 'Integrating',
    description: 'For engineers: connect an app through the API or Azure Service Bus.',
  },
  {
    id: 'reference',
    title: 'Reference',
    description: 'Terms and definitions.',
  },
]

export function isSectionId(v: unknown): v is SectionId {
  return typeof v === 'string' && (SECTION_IDS as readonly string[]).includes(v)
}

export function sectionById(id: SectionId): HelpSection {
  return SECTIONS.find((s) => s.id === id)!
}

/** The guided path shown at the top of the help center. */
export const START_HERE = ['welcome', 'concepts', 'tutorial-first-application'] as const

export const ROLES = ['admin', 'editor', 'viewer'] as const
export type HelpRole = (typeof ROLES)[number]
